import QRCode from "qrcode";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getType, PDF_PAGE_SIZE, getStatus } from "../../util"
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function compare(a, b){
    if (a.date > b.date) return -1;
    if (b.date > a.date) return 1;

    return 0;
}

export async function generateQR(uId, vehicleDict, customInspectionDict, vIds) {
    const opts = {
        errorCorrectionLevel: 'H',
        level: 6,
        margin:2,
        scale: 20,
    }
    
    const optsCustom = {
        errorCorrectionLevel: 'H',
        level: 8,
        margin:2,
        scale: 20,
    }

    var docDefinition = {
        content: [],
        styles: {
            header: {
                fontSize: 12,
                bold: true,
                margin: [30, 0, 0, 0],
                color: 'grey'
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
        }
    }

    for (var ind = 0; ind < vIds.length; ind++) {
        const vehicle = vehicleDict[vIds[ind].id]
        const customInspection = customInspectionDict[vehicle.vehicleData.type]

        var data = "02CC"
        data += customInspection.fallback
        data += vehicle.id
        data += uId
        data += customInspection.id
        
        const image = (await QRCode.toDataURL(data, customInspection.id === "0" ? opts : optsCustom))
        
        docDefinition.content.push(
            { text: vehicle.vehicleData.unitNumber, style: 'header' },
            { text: ' Make/Model: ' + vehicle.vehicleData.make + ' License: ' + vehicle.vehicleData.lic, style: 'header' },
            { image: image, width: 525 },
        )

        if (ind + 1 < vIds.length) {
            docDefinition.content.push({ text:"", pageBreak: 'before' })
        }
    }

    const fileName = "Batch-of-" + String(vIds.length) + "-QRCodes.pdf";

    pdfMake.createPdf(docDefinition).download(fileName);
}

export async function generatePDF(rawInspections, customDict, startDate, endDate, workorder, getPhoto) {
    
    if (rawInspections.length === 0) {
        return 0
    }

    const inspections = rawInspections.sort(compare)

    let w = 1
    let h = 1
    var i = new Image(); 
    var lc = 6;
    const vehicleData = inspections[0].vehicleData;

    var docDefinition = {
        content: [
            { text: 'Audit for ' + (vehicleData.unitNumber), style: 'subheader' },
            { text: 'Between Dates: ' + startDate.toDateString() + " - " + endDate.toDateString(), style: 'subheader' },
            'Jur/Lic/VIN:  ' + (vehicleData.jurisdiction) + " / " + (vehicleData.lic) + " / " + (vehicleData.vin),
            'Type/Make/Year:  ' + getType(vehicleData.type, customDict) + " / " + (vehicleData.make) + " / " + (vehicleData.year),
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 14,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
        }
    };

    for (var ind = 0; ind < inspections.length; ind++) {
        const inspection = inspections[ind];
        const signature = (await getPhoto(inspection.metadata.signature))

        lc += 10
        if (!workorder && lc > PDF_PAGE_SIZE) {
            docDefinition.content.push({ text:"", pageBreak: 'before' })
            lc = 0
        }

        docDefinition.content.push(
            { text: 'Inspection On ' + (inspection.name), style: 'subheader' },
            'Date: ' + (inspection.date),
            'Overall Status: ' + (inspection.status),
            'Company/Operator/location:  ' + (inspection.metadata.operatorName) + " / " + (inspection.metadata.name) + " / " + (inspection.metadata.location),
            'Signature:  ',
            ( signature ? { image: signature, width: 50 } : "n/a" )
        )

        if (inspection.items.length === 0) {
            docDefinition.content.push("No Defects Found on Vehicle")
        }
        
        for(let iInd = 0; iInd < inspection.items.length; iInd++) {
            const item = inspection.items[iInd]
            const photo = (await getPhoto(item.photoKey))
            
            i.onload = () => {
                w = i.width
                h = i.height
            };
            
            i.src = photo;

            lc += 6 + Math.max((12*h/w), item.comment.length / 12)
            if (!workorder && lc > PDF_PAGE_SIZE) {
                docDefinition.content.push({ text:"", pageBreak: 'before' })
                lc = 0
            }

            var body = [
                ['Title', 'Status', 'Comments', 'Image'],
                [
                    item.title,
                    getStatus(String(item.condition)),
                    item.comment,
                    ( photo ? { image: photo, width: 150 } : "n/a" ),
                    
                ],
            ]

            if (workorder) {
                body.push([
                    "Signoff:",
                    "Date:",
                    "Responsible Person:",
                    "Corrective Action:\n\n\n\n\n\n\n\n\n\n\n\n",
                ])
            }

            docDefinition.content.push({
                style: 'tableExample',
                table: {
                    widths: [100, 50, 200, 150],
                    body: body
                }
            })

            if (workorder) {
                if (iInd + 1 < inspection.items.length) {
                    docDefinition.content.push({ text:"", pageBreak: 'before' })
                }
            }
            
        }

    }

    const name = (vehicleData.unitNumber) + '-audit.pdf';
    pdfMake.createPdf(docDefinition).download(name);
}
